import { createApiSlice } from "@common";
import { CRUD_PROCUREMENT_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addProcurementStatus",
    method: "post",
    url: CRUD_PROCUREMENT_STATUS,
    stateKey: "message",
  },
  {
    name: "getProcurementStatus",
    method: "get",
    url: CRUD_PROCUREMENT_STATUS,
    stateKey: "data",
  },
  {
    name: "updateProcurementStatus",
    method: "put",
    url: CRUD_PROCUREMENT_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteProcurementStatus",
    method: "delete",
    url: CRUD_PROCUREMENT_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"procurementStatus",
 apiConfig, 
 customReducers);
const procurementStatusSlice = slice;

export default procurementStatusSlice.reducer;

export const {
  addProcurementStatus,
  getProcurementStatus,
  updateProcurementStatus,
  deleteProcurementStatus,
} = thunks;

export const { rowSelect } = actions;
